import { Navigate } from 'react-router';

import { TabbedLayout } from '../../components/TabbedLayout';
import { useCan } from '../../lib/permissions';

const TABS = [
  { to: '/staff/settings', label: 'General' },
  { to: '/staff/settings/users', label: 'Users' },
  { to: '/staff/settings/payments', label: 'Payments' },
  { to: '/staff/settings/notifications', label: 'Notifications' },
  { to: '/staff/settings/security', label: 'Security' },
];

/** For tidiness only: the API checks permissions on every route. */
export function SettingsLayout() {
  const canManage = useCan('org.manage');
  if (!canManage) return <Navigate to="/staff" replace />;
  return <TabbedLayout title="Settings" label="Settings sections" tabs={TABS} />;
}
